
import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  name: "LogPanel"
})
export default class LogPanel extends Vue {
  logContent: string = "";
  currentLabel: "all" | "error" | "warning" | "message" = "all";
  allLogs: any[] = [];
  errorLogs: any[] = [];
  warningLogs: any[] = [];
  messageLogs: any[] = [];

  clearLog() {
    this.logContent = "";
    this.allLogs = [];
    this.errorLogs = [];
    this.warningLogs = [];
    this.messageLogs = [];
  }

  error(content: string) {
    const errorObj = {
      type: "error",
      content: content
    };
    this.allLogs.push(errorObj);
    this.errorLogs.push(errorObj);
  }

  warning(content: string) {
    const warningObj = {
      type: "warning",
      content: content
    };
    this.allLogs.push(warningObj);
    this.warningLogs.push(warningObj);
  }

  message(content: string) {
    const messageObj = {
      type: "message",
      content: content
    };
    this.allLogs.push(messageObj);
    this.messageLogs.push(messageObj);
  }
}
